import React, { Component } from 'react';
import 'core-js/modules/es6.number.is-nan';
import Responsive from 'react-responsive';
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom';
import Swiper from 'swiper/esm/components/core/core-class';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import Pagination from 'swiper/esm/components/pagination/pagination';
import Navigation from 'swiper/esm/components/navigation/navigation';
import Scrollbar from 'swiper/esm/components/scrollbar/scrollbar';
import 'swiper/swiper-bundle.min.css';

import styles from './index.scss';
import Mobile from '../../../../components/Responsive/Mobile';
import { withLocaleContext } from '../../../../hocs/LocaleContext';
import { DESKTOP_BREAKPOINT_MIN } from '../../../../../config/consts';

// const HIDDEN_DOT_INDEX = 4;
const MAIN_BULLET_QTY = 3;
const DESKTOP_CARDS_QTY = 6;
const TABLET_CARDS_QTY = 4;

class Carousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            swiper: null,
            shouldLoadImages: false,
            // itemsInViewPort: DESKTOP_CARDS_QTY,
            // totalNumOfItems: this.items.length,
            // lastSlideIndex: this.totalNumOfItems - this.itemsInViewPort,
            // shouldHideDot: this.totalNumOfItems > this.itemsInViewPort + HIDDEN_DOT_INDEX - 1,
        };
    }

    // startLoadingImages() {
    //     this.setState({ shouldLoadImages: true });
    // }
    componentDidUpdate(prevProps) {
        if (this.state.swiper && prevProps.children.length !== this.props.children.length) {
            this.state.swiper.update();
            this.state.swiper.pagination.update();
        }
    }

    render() {
        const desktopParams = {
            Swiper,
            direction: 'horizontal',
            modules: [Pagination, Navigation],
            shortSwipes: false,
            longSwipesRatio: 0.1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                dynamicBullets: true,
                dynamicMainBullets: MAIN_BULLET_QTY,
                loop: false,
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: DESKTOP_CARDS_QTY,
            slidesPerGroup: 4, // swiper lib issue
            watchOverflow: true,
            watchSlidesVisibility: true,
            spaceBetween: 20,
            breakpoints: {
                960: {
                    slidesPerView: TABLET_CARDS_QTY,
                    slidesPerGroup: 3, // swiper lib issue
                },
            },
        };
        const mobileParams = {
            Swiper,
            direction: 'horizontal',
            modules: [Scrollbar],
            slidesPerView: 'auto',
            shortSwipes: false,
            longSwipesRatio: 0.1,
            spaceBetween: 15,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
        };
        const carouselItems = this.props.children;
        return (
            <div className={styles.CarouselContainer}>
                {carouselItems.length ? (
                    <React.Fragment>
                        <div
                            className={classNames({
                                [styles.CarouselTitle]: true,
                                [this.props.extraClassForTitle]: this.props.extraClassForTitle,
                            })}
                        >
                            {this.props.title}
                        </div>
                        <Responsive minWidth={DESKTOP_BREAKPOINT_MIN}>
                            <ReactIdSwiperCustom
                                {...desktopParams}
                                {...this.props.additionalParams}
                                getSwiper={swiper => {
                                    this.setState({ swiper });
                                }}
                            >
                                {carouselItems}
                            </ReactIdSwiperCustom>
                        </Responsive>
                        <Mobile>
                            <ReactIdSwiperCustom
                                {...mobileParams}
                                getSwiper={swiper => {
                                    this.setState({ swiper });
                                }}
                            >
                                {carouselItems}
                            </ReactIdSwiperCustom>
                        </Mobile>
                    </React.Fragment>
                ) : null}
            </div>
        );
    }
}

Carousel.propTypes = {
    removeRecentlyViewedProduct: PropTypes.object,
    cc: PropTypes.string.isRequired,
    lc: PropTypes.string.isRequired,
    additionalParams: PropTypes.object,
    title: PropTypes.string,
    extraClassForTitle: PropTypes.string,
};
Carousel.defaultProps = {
    additionalParams: {},
};

export default withLocaleContext(Carousel);
